import ChunkBase from './ChunkBase';
import { BodyTypes } from './LevelManager';

export default class PlatformImageBase extends Phaser.Physics.Matter.Image {
  public static events = {
    Init: 'init'
  } as const;

  public zIndex: number;

  protected chunk: ChunkBase | undefined;
  protected isMovingPlatform: boolean;
  protected hasCustomBody: boolean;
  // protected customBodies: MatterJS.BodyType[];

  constructor(scene: Phaser.Scene, x: number, y: number, texture: string, frame?: number | string) {
    super(scene.matter.world, x, y, texture, frame, {
      label: BodyTypes.Platform,
      isStatic: true
    });

    this.zIndex = 0;
    this.isMovingPlatform = false;

    this.hasCustomBody = false;
    // this.customBodies = [];
  }

  get IsMovingPlatform() {
    return this.isMovingPlatform;
  }

  set IsMovingPlatform(newValue: boolean) {
    this.isMovingPlatform = newValue;
  }

  public init() {
    (this.body as MatterJS.BodyType).label = BodyTypes.Platform;
    this.scene.matter.body.setStatic(this.body as MatterJS.BodyType, true);

    this.emit(PlatformImageBase.events.Init);
  }

  public bindChunk(chunk: ChunkBase) {
    this.chunk = chunk;
  }

  public reset() {
    this.alpha = 1;
    this.scale = 1;
    this.setVisible(true);
    this.setActive(true);

    // if (this.isMovingPlatform) {
    //   SimpleMover.clearComponent(this);
    // }
  }

  public recycle(removeFromChunk: boolean = false) {
    this.scene.tweens.killTweensOf(this);
    this.setVisible(false);
    this.setActive(false);
    this.setPosition(-1000, 0);

    if (removeFromChunk) this.chunk?.removePlatform(this);
    this.chunk = undefined;
  }

  public destroy(fromScene?: boolean | undefined): void {
    // if (this.hasCustomBody) {
    //   this.customBodies.forEach((body) => {
    //     this.scene.matter.world.remove(body);
    //     console.log("Custom body removed");
    //   });
    // }

    this.scene?.tweens?.killTweensOf(this);

    super.destroy(fromScene);
  }
}
